import SubmitFeedback from '@/components/submit-feedback';

export default SubmitFeedback;
